export default theme => ({
  root: {},
  button: {
    marginLeft: theme.spacing(1)
  },
  wrapper: {
    display: 'flex',
    margin: theme.spacing(2)
  },
  wrapperChild: {
    flex: 1,
  },
  driverDetail: {
    margin: theme.spacing(1)
  },
  donationButton: {
    display: 'flex'
  }
});
